import React, { useState } from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import PageLayout from "../../components/PageLayout";
import FAQ from "../../components/FAQ";
import SEO from "../../components/SEO";
import { ContactModal } from "../../components/calltoactions/ContactModal";
import { contact } from "../../config/site";
import { getServiceContent } from "../../config/servicesContent";

const ServicePage = () => {
  const { slug } = useParams();
  const content = getServiceContent(slug);
  const [isOpen, setIsOpen] = useState(false);

  if (!content) {
    return <Navigate to="/" replace />;
  }

  const path = `/services/${slug}`;

  return (
    <>
    <PageLayout>
      <SEO
        title={content.pageTitle}
        description={content.metaDescription}
        path={path}
        faqItems={content.faqItems}
        breadcrumbs={[
          { name: "דף הבית", url: "/" },
          { name: "שירותים", url: "/#services" },
          { name: content.breadcrumb, url: path },
        ]}
      />

      <section className="content_page_hero">
        <div className="container">
          <ul className="breadcrumb">
            <li>
              <Link to="/">דף הבית</Link>
            </li>
            <li>
              <Link to="/#services">שירותים</Link>
            </li>
            <li>{content.breadcrumb}</li>
          </ul>
          <h1>{content.h1}</h1>
          <p className="hero_subtitle">{content.heroSubtitle}</p>
        </div>
      </section>

      <section className="page_section">
        <div className="container page_content">
          <div className="page_intro_grid">
            <div>
              <div className="shane_tm_title">
                <span>{content.introSpan}</span>
                <h2>{content.introTitle}</h2>
              </div>
              {content.introParagraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
            <div>
              <ul>
                {content.introBullets.map((b) => (
                  <li key={b}>{b}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="page_section bg_light">
        <div className="container page_content">
          <div className="shane_tm_title">
            <span>{content.cardsSpan}</span>
            <h2>{content.cardsTitle}</h2>
          </div>
          <div className="page_cards">
            {content.cards.map((card) => (
              <div className="card" key={card.title}>
                <div className="card_icon">{card.icon}</div>
                <h3>{card.title}</h3>
                <p>{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="page_section">
        <div className="container page_content">
          <div className="shane_tm_title">
            <span>{content.processSpan}</span>
            <h2>{content.processTitle}</h2>
          </div>
          <div className="page_steps">
            {content.processSteps.map((step) => (
              <div className="step" key={step.n}>
                <div className="step_number">{step.n}</div>
                <div className="step_content">
                  <h3>{step.title}</h3>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="page_section bg_light">
        <div className="container page_content">
          <div className="shane_tm_title">
            <span>{content.faqSpan}</span>
            <h2>{content.faqTitle}</h2>
          </div>
          <FAQ items={content.faqItems} />
        </div>
      </section>

      <section className="page_cta_banner">
        <div className="container">
          <h2>{content.ctaTitle}</h2>
          <p>{content.ctaText}</p>
          <div className="cta_buttons">
            <a href={contact.phones[0].href} className="cta_primary">
              התקשרו עכשיו — {contact.phones[0].label}
            </a>
            <button className="cta_secondary" onClick={() => setIsOpen(true)}>
              שלחו הודעה
            </button>
          </div>
        </div>
      </section>
    </PageLayout>
    <ContactModal isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};

export default ServicePage;
